import DemandesLivraisonsController from './demandes.livraisons.controller';

export default {
    template: require('./demandes.livraisons.html'),
    controller: DemandesLivraisonsController
};
